import $http from '@Config/axios';

export default {
  pegarNotificacoes(params) {
    return new Promise((resolve, reject) => {
      $http.get('notification/notificacoes', { params })
        .then(response => resolve(response))
        .catch(response => reject(response));
    });
  },

  index(params) {
    return new Promise((resolve, reject) => {
      $http.post('notification/index', params)
        .then(response => resolve(response))
        .catch(response => reject(response));
    });
  },
  updateVisualizacao(params) {
    return new Promise((resolve, reject) => {
      $http.put(`notification/${params.id}/updateVisualizacao`)
        .then(response => {
          resolve(response);
        })
        .catch(response => reject(response));
    });
  }
};
